import { Types } from '@store/types';

export const saveTrendResearchUserPreference = (data) => async (dispatch) => {
	dispatch({
		type: Types.SAVE_TREND_RESEARCH_USER_PREFERENCE,
		payload: data
	});
};

export const setSelectedPreferenceForFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_SELECTED_PREFERENCE_FOR_FILTER,
		payload: data
	});
};

export const setDefaultSelectedPreferenceForFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_DEFAULT_SELECTED_PREFERENCE_FOR_FILTER,
		payload: data
	});
};

export const toggleBothMarketAndFabricTypes = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_BOTH_MARKET_AND_FABRIC_TYPES,
		payload: data
	});
};

export const toggleSelectedBrandForFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_SELECTED_BRANDS_FOR_FILTER,
		payload: data
	});
};
export const toggleMultipleSelectedBrandForFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_MULTIPLE_SELECTED_BRANDS_FOR_FILTER,
		payload: data
	});
};

export const toggleAllBrandSelectionForFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_ALL_BRANDS_FOR_FILTER,
		payload: data
	});
};

export const setTrendResearchOnboardedBrands = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_ALL_TREND_RESEARCH_BRAND_LIST,
		payload: data
	});
};

export const setBrandInsightSummary = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_BRAND_INSIGHT_SUMMARY,
		payload: data
	});
};

export const setExploreProductsSourceType = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_EXPLORE_PRODUCTS_SOURCE_TYPE,
		payload: data
	});
};

export const setInstagramInfluencerList = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_ALL_INSTAGRAM_INFLUENCER,
		payload: data
	});
};

export const toggleAllInstagramInfluencerList = (data) => async (dispatch) => {
	dispatch({
		type: Types.SELECT_ALL_INSTAGRAM_INFLUENCER,
		payload: data
	});
};

export const toggleInstagramInfluencer = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_INSTAGRAM_INFLUENCER,
		payload: data
	});
};

export const setSingleMoodboard = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_SINGLE_MOODBOARD,
		payload: data
	});
};
export const setTrendResearchDateRange = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_TREND_RESEARCH_FILTER_CALENDAR,
		payload: data
	});
};
export const setAllMoodboards = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_ALL_MOODBOARD,
		payload: data
	});
};
